import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

const FaqModule = ({ module, sectionColor = 'orange', sectionId }) => {
    return (
        <section className={`sec-faq-wohnen sec-${sectionColor}-color`}>
            <div className={`accordion-sec-wrapper pt-pb-10 ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`} id={sectionId}>
                <div className="container">
                    <h2 className="mb-3 mb-lg-4 text-darkgrey">{module?.Titel}</h2>
                    <div className="accordion" id={`accordion-${module?.id}`}>
                        {module?.FAQ_Data?.map((item, index) => (
                            <div className="accordion-item" key={item.id}>
                                <div className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${item?.id || index}`}>
                                        {item.Titel}
                                    </button>
                                </div>
                                <div id={`collapse-${item?.id || index}`} className="accordion-collapse collapse" data-bs-parent={`#accordion-${module?.id}`}>
                                    <div className="accordion-body">
                                        {/* <p>{item.answer}</p> */}
                                        {item?.Text && <BlocksRenderer
                                            content={item?.Text}
                                            blocks={{
                                                link: ({ children, url, target, rel }) => (
                                                    <a
                                                        href={url}
                                                        target={target || "_blank"}
                                                        rel={rel || undefined}
                                                    >
                                                        {children}
                                                    </a>
                                                ),
                                            }} />}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FaqModule